import React, { useContext, useState, useEffect } from "react";
import { authContext } from "./AuthProvider";
import { NavLink } from "react-router-dom";
import { themeContext } from "./ThemeProvider";
import { Dropdown } from "semantic-ui-react";
import OrderNotifications from "../components/Notifications/OrderNotifications.jsx";
import UnifiedOrdersTable from "../components/OrderComponents/UnifiedOrdersTable.jsx";
import PendingOrders from "../components/OrderComponents/PendingOrders.jsx";
import VodafoneOrdersTable from "../components/OrderComponents/VodafoneOrdersTable.jsx";

import { isOnboarded } from "../libs/utils";
import "./LandingPage.css";

const PENDING_SUPPLIER_OPTIONS = [
  { key: "all",      text: "All suppliers", value: "all" },
  { key: "zen",      text: "ZEN",           value: "zen" },
  { key: "vodafone", text: "Vodafone",       value: "vodafone" },
];

export default function LandingPage() {
  const { permissions } = useContext(authContext);
  const { assets } = useContext(themeContext);
  const [isVodafoneOnboarded, setIsVodafoneOnboarded] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  useEffect(() => {
    isOnboarded('Vodafone')
      .then(setIsVodafoneOnboarded)
      .catch(() => setIsVodafoneOnboarded(false));
  }, [permissions]);
  const [showOrders, setShowOrders] = useState(false);
  const [showPendingOrders, setShowPendingOrders] = useState(false);
  const [pendingSupplierFilter, setPendingSupplierFilter] = useState("all");

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("devMode") === "1") {
      sessionStorage.setItem("devMode", "1");
    }
  }, []);

  function switchTab(tab) {
    setShowNotifications(tab === "notifications");
    setShowOrders(tab === "orders");
    setShowPendingOrders(tab === "pending");
  }

  return (
    <div
      className="landing-page__container"
      style={{ backgroundColor: assets?.backgroundColour || "#FFFFFF" }}
    >
      <header className="landing-page__header">
        <img
          className="landing-page__logo"
          src={assets.logo}
          alt="App Logo"
          style={assets.logoNavStyle}
        />
        <h1 style={{ color: assets?.headerColour }}>Order Management</h1>
      </header>

      <div className="landing-page__content">
        <section className="landing-page__section">
          <div
            className="landing-page__nav-items"
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            {permissions.orderAccess && (
              <NavLink
                className="landing-page__nav-link"
                to="#"
                activeClassName="activated"
                onClick={() => switchTab("orders")}
                style={{ backgroundColor: assets?.headerColour, color: "white" }}
              >
                Orders
              </NavLink>
            )}
            <NavLink
              className="landing-page__nav-link"
              to="#"
              activeClassName="activated"
              onClick={() => switchTab("notifications")}
              style={{ backgroundColor: assets?.headerColour, color: "white" }}
            >
              Notifications
            </NavLink>
            {permissions?.pendingOrders && (
              <NavLink
                className="landing-page__nav-link"
                to="#"
                activeClassName="activated"
                onClick={() => switchTab("pending")}
                style={{ backgroundColor: assets?.headerColour, color: "white" }}
              >
                Pending Orders
              </NavLink>
            )}
          </div>
        </section>

        {showOrders && <UnifiedOrdersTable />}

        {showNotifications && <OrderNotifications />}

        {showPendingOrders && (
          <>
            {isVodafoneOnboarded && (
              <div style={{ margin: "12px 0", display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ fontWeight: 600 }}>Supplier:</span>
                <Dropdown
                  inline
                  options={PENDING_SUPPLIER_OPTIONS}
                  value={pendingSupplierFilter}
                  onChange={(_, { value }) => setPendingSupplierFilter(value)}
                />
              </div>
            )}
            {(pendingSupplierFilter === "all" || pendingSupplierFilter === "zen") && (
              <>
                {pendingSupplierFilter === "all" && isVodafoneOnboarded && (
                  <p style={{ fontWeight: 600, marginBottom: "4px" }}>ZEN</p>
                )}
                <PendingOrders />
              </>
            )}
            {isVodafoneOnboarded && (pendingSupplierFilter === "all" || pendingSupplierFilter === "vodafone") && (
              <>
                {pendingSupplierFilter === "all" && (
                  <p style={{ fontWeight: 600, margin: "24px 0 4px" }}>Vodafone</p>
                )}
                <VodafoneOrdersTable statusFilter="Pending" />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
